export interface publicProfileInfo {
  about: string;
  facebookUrl: string;
  instagramUrl: string;
  linkedInUrl: string;
  spotifyUrl: string;
  tiktokUrl: string;
  twitchUrl: string;
  twitterUrl: string;
  profileTheme: string;
}

export interface careerDemographicsInfo {
  jobTitle: string;
  company: string;
  website: string;
  industry: string;
  secondaryIndustries: string[];
  raceEthnicity: string[];
  ageRange: string;
  genderIdentity: string[];
}
import { Timestamp } from "firebase/firestore";
import { Pass } from "./pass";

export enum UserRoles {
  admin = "admin",
  user = "user",
  creator = "creator",
  partner = "partner",
}

export type UserPassStatus =
  | "PASS_ASSIGNED"
  | "PASS_UNASSIGNED"
  | "PASS_ASSIGN_REQUESTED";

export const userPassStatus: Record<string, UserPassStatus> = {
  ASSIGNED: "PASS_ASSIGNED",
  UNASSIGNED: "PASS_UNASSIGNED",
  ASSIGN_REQUESTED: "PASS_ASSIGN_REQUESTED",
};

export interface DiscordIntegration {
  userId: string;
  username: string;
  discriminator?: string; // Legacy Discord discriminator (for old accounts)
  globalName?: string; // New Discord display name
  avatar?: string;
  connectedAt: Timestamp;
}

export interface UserIntegrations {
  discord?: DiscordIntegration;
}

export interface User {
  uid: string;
  email?: string;
  phoneNumber?: string;
  motivations?: string[];
  firstName?: string;
  lastName?: string;
  tags?: string[];
  authProvider: string;
  photoUrl?: string;
  publicProfileInfo?: publicProfileInfo;
  careerDemographicsInfo?: careerDemographicsInfo;
  role: UserRoles;
  profilePhotoFileName?: string;
  passes?: UserPass[];
  partnerEvents?: string[];
  sharedForms?: string[];
  integrations?: UserIntegrations;
}

export interface UserPass {
  id: string;
  item: UserPassItem;
  passId: string;
  passPriceId: string;
  paymentId: string;
  priceId: string;
  productId: string;
  timestamp: Date;
  qrString: string;
  ownerId: string;
  status: UserPassStatus;
  assignedTo?: {
    uid: string;
    firstName: string;
    lastName: string;
    email: string;
    passAssignRequestTimestamp?: Date;
    passAssignConfirmTimestamp?: Date;
  };
  pass?: Pass;
  // New fields for dual-collection support and past events filtering
  ticketTypeSlug?: string; // e.g., "tribe", "vip" - for matching with ticketTypes collection
  festivalYear?: number; // e.g., 2026 - for filtering past festivals
  eventDate?: string; // ISO date string for event-specific passes (Tech Luncheon, VIP Dinner)
  eventName?: string;
}

export interface UserPassItem {
  name: string;
  amount_discount: number;
  amount_total: number;
  amount_subtotal: number;
}

export interface Customer {
  id: string;
  email: string;
  stripeId: string;
  stripeLink: string; 
}

export interface ExtendedFormResponseInput {
  id: string;
  userId: string;
  formId: string;
  // header: string;
  response: object;
  // responseType: ExtendedFormResponseInputResponseType;
  timestamp: Timestamp;
  addedBy: {uid: string, name: string};
}
